import React from 'react'

import Button from '../Shared/Button'
import AppIcon from './Icon'
import { defaultBranding } from './AppDetails'

import './DeepLinkPrompt.css'

const DeepLinkPrompt = ({
  app,
  nativeAppURL,
  isCustomFallback,
  onFallback,
}) => {
  const { id, name } = app
  const branding = app.branding || defaultBranding

  const handleOpenInApp = () => {
    // A user tap is what iOS expects before handing off to another app.
    window.location.href = nativeAppURL
  }

  return (
    <div className="deep-link-prompt">
      <div className="deep-link-prompt-content">
        <AppIcon appId={id} name={name} />
        <h1 title={name}>{name}</h1>
        <div className="deep-link-prompt-actions">
          <Button backgroundColor={branding.primary} onClick={handleOpenInApp}>
            Open in App
          </Button>
          <button
            type="button"
            className="btn deep-link-prompt-browser-button"
            style={{ color: branding.primary, borderColor: branding.primary }}
            onClick={onFallback}
          >
            {isCustomFallback ? 'Get the App' : 'Continue in Browser'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default DeepLinkPrompt
